import React, { FC } from 'react';
import classNames from 'classnames';

import EventStatusIndicator from 'components/events/EventStatusIndicator';

import { useEvent } from 'components/context/EventContext';

import useStyles from './style';

const Status: FC = () => {
  const classes = useStyles();

  const { event, isHistory, isEventLocked } = useEvent();

  return isHistory ? null : (
    <div className={classNames('status', classes.status)} data-hash="statusinput">
      <EventStatusIndicator event={(event as unknown) as EventItem} />
      {!!event?.daysCountBeforeLock && !isEventLocked && !!event?.date ? (
        <span>{`Will be locked in ${event?.daysCountBeforeLock} days`}</span>
      ) : null}
    </div>
  );
};

export default Status;
